export default __webpack_public_path__ + "static/media/get-touch.8d1270e5.png";